import _ from 'lodash';

import {
  fieldMapping,
} from '../../Enum/FieldMapping/PersonProfileFieldMapping';
import { mappingActions } from '../../Store/Reducers/MappingReducer';
import { utilsActions } from '../../Store/Reducers/UtilsReducer';
import {
  isContent,
  isContentErr,
} from '../../Utils/Response/Response';
import {
  getDetailExistingPersonProfile,
  getDetailPersonProfile,
  postApproveMappingPersonProfile,
  postPersonProfileCountData,
  postPersonProfileList,
  postPersonProfileSearchCountData,
  postSearchPersonProfileList,
} from '../Api/PersonProfileAPI';
import {
  reloadList,
  setDefaultPagination,
} from './DashboardData';
import {
  approvalAction,
  approvalActionErr,
  setMappingForm,
  setMappingSearch,
  setMappingSearchErr,
} from './MappingData';
import { dashboardAction } from '../../Store/Reducers/DashboardReducer';

export const fetchDataPersonProfileList = (
  totalRow,
  countData,
  token,
  currentPage,
  rowLimit,
  sortDate,
  dispatch,
  notify
) =>
  postPersonProfileCountData(token, notify, dispatch, response =>
    listData(
      response,
      totalRow,
      countData,
      token,
      currentPage,
      rowLimit,
      sortDate,
      dispatch,
      notify
    )
  );

const listData = async (
  res,
  totalData,
  countData,
  token,
  currentPage,
  rowLimit,
  sortDate,
  dispatch,
  notify
) => {
  await dispatch(mappingActions.setCountData(isContent(res)));
  await dispatch(dashboardAction.setTotalRow(isContent(res)));

  if (totalData === countData) {
    postPersonProfileList(token, currentPage, rowLimit, sortDate, dispatch, notify, response =>
      dispatch(mappingActions.setList(isContent(response)))
    );
  } else {
    setDefaultPagination(dispatch);
    await postPersonProfileList(token, 1, 10, sortDate, dispatch, notify, response =>
      reloadList(response, dispatch, countData)
    );
  }
  dispatch(utilsActions.setLoading(false));
};

export const fetchPersonProfileMappingForm = async (
  token,
  dispatch,
  uniqueKey,
  NewId,
  ExistId,
  list,
  notify,
  navigate
) => {
  const newData = await getDetailPersonProfile(
    token,
    NewId,
    notify,
    dispatch,
    res => isContent(res),
    err => isContentErr(err)
  );
  const existData = await getDetailExistingPersonProfile(
    token,
    ExistId,
    notify,
    dispatch,
    res => isContent(res),
    err => isContentErr(err)
  );
  await setMappingForm(fieldMapping, list, uniqueKey, newData, existData, dispatch);
  navigate();
};

export async function fetchSearchPersonProfileList(token, data, column, dispatch, notify) {
  await postSearchPersonProfileList(
    token,
    data,
    dispatch,
    notify,
    res => setMappingSearch(res, column, dispatch),
    err => setMappingSearchErr(err, dispatch)
  );
}

export const fetchDataPersonProfileSearchList = async (
  token,
  currentPage,
  rowLimit,
  filter,
  column,
  dispatch,
  notify
) => {
  postPersonProfileSearchCountData(token, filter, notify, dispatch, response =>
    listSearchData(response, token, currentPage, rowLimit, filter, column, dispatch, notify)
  );
};
const listSearchData = async (
  res,
  token,
  currentPage,
  rowLimit,
  filter,
  column,
  dispatch,
  notify
) => {
  let data = await {...{page: currentPage, limit: Number(rowLimit)}, ...filter};
  await postSearchPersonProfileList(
    token,
    data,
    dispatch,
    notify,
    reponse => setMappingSearch(reponse, column, isContent(res), dispatch),
    err => setMappingSearchErr(err, isContent(res), dispatch)
  );
  dispatch(utilsActions.setLoading(false));
};

export async function fetchDataApprovalPersonProfile(
  token,
  data,
  mappingList,
  mappingCount,
  notify,
  dispatch
) {
  let dataSubmit = data;
  let checkAdditionalFormat =
    _.has(data.additional_info[0], "key") && _.has(data.additional_info[0], "value");
  if (!checkAdditionalFormat) {
    dataSubmit = {...data, ...{additional_info: null}};
  }
  return postApproveMappingPersonProfile(
    token,
    dataSubmit,
    notify,
    dispatch,
    res => approvalAction(res, mappingList, mappingCount, dispatch),
    err => approvalActionErr(err, dispatch)
  );
}
